import React, { useState, useEffect } from "react";
import FilterRowSection from "../FilterRowSection/FilterRowSection";
import Card from "../Card/Card";
import thum from "../../Marketplace/Banner/assets/thum.png";
import thum2 from "../../Marketplace/Banner/assets/thum2.png";
import Web3 from "web3";
import abi from "constants/abi";
import contracts from "constants/contracts";
import { useBalance, useAccount } from "wagmi";
import multicall from "utils/multicall";
import getNodeUrl from '../../../utils/getRpcUrl';

var rpc =getNodeUrl()
const web3 = new Web3(new Web3.providers.HttpProvider(rpc));
const contractNFT = new web3.eth.Contract(abi.NFT1, contracts.NFT1);
const contractMARKETPLACE = new web3.eth.Contract(
  abi.MARKETPLACE,
  contracts.MARKETPLACE
);


const ExploreCardsSection = ({ sideBarFilter }) => {
  const { address } = useAccount();
  const { data, isError, isLoading } = useBalance({
    address: address,
  });
  const [mainData, setmainData] = useState([]);
  const [NoOfListedItems, setNoOfListedItems] = useState(0);
  const [Bid, setBid] = useState(0);



  //multicall
  useEffect(() => {
  
    async function main() {
      var callsALL = [
        {
          address: contracts.MARKETPLACE,
          params: [],
          name: "numberOfItemsListed",
        },
        {
          address: contracts.MARKETPLACE,
          params: [],
          name: "getMarketItems",
        },
      ];

      let NooItems;
      let marketItems;
      [NooItems, marketItems] = await multicall(abi.MARKETPLACE, callsALL);

      console.log(marketItems[0]);
      const newArray = marketItems[0];
      // Function to extract tokenId and tokenContract
      function extractTokenData(item) {
        return {
          tokenId: item.tokenId._hex,
          contractAddress: item.tokenContract,
        };
      }

      // Using the function to extract the required information
      const newArrayForUri = newArray.map(extractTokenData);

      // Map the data and flatten it, because each item is transformed to an array of two objects
      const callsALLForUri = [].concat.apply(
        [],
        newArrayForUri.map(transformItemToDesiredStructure)
      );

      console.log(callsALLForUri);
      const uris = new Array(callsALLForUri.length).fill(null);
      const results = await multicall(abi.NFT1, callsALLForUri);
      console.log(results);

      uris.forEach((_, index) => {
        uris[index] = results[index];
      });
      const newData = newArray.map((item, index) => {
        return {
          ...item,
          uri: uris[index],
        };
      });
      console.log(newData);

      setNoOfListedItems(Number(NooItems));
      setmainData(newData);
    }
    main();
  }, [address]);

  let dataMain = mainData;
  if (sideBarFilter.tier1) {
    dataMain = mainData.filter((single) => !single.gold);
    console.log(dataMain);
  } else if (sideBarFilter.tier2) {
    dataMain = mainData.filter((single) => single.gold);
  }

  return (
    <div>
      <FilterRowSection NoOfListedItems={NoOfListedItems} />
      <div className="flex flex-wrap justify-center 4xl:grid grid-cols-5 gap-[30px] mt-[30px] overflow-x-hidden">
        {dataMain.slice(0, 15).map((single, i) => (
          <Card key={i} address={address} {...single}></Card>
        ))}
      </div>
      <div className="flex justify-center mt-[40px] mb-[40px] md:mb-[132px]">
        {dataMain.slice(0, 15).length ? (
          <button className="w-[154px] text-[15px] font-bold h-[44px] border border-white rounded-[30px]">
            Load More
          </button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

function transformItemToDesiredStructure(item) {
  const tokenId = item.tokenId;
  const contractAddress = item.contractAddress;

  return [
    {
      address: contractAddress,
      params: [tokenId],
      name: "tokenURI",
    },
  ];
}

export default ExploreCardsSection;
